/* eslint-disable */
// because legacy

import 'core-js/stable'
import 'regenerator-runtime/runtime'

import 'bootstrap/js/dropdown'
import 'bootstrap/js/tooltip'
import 'bootstrap/js/popover'
import 'bootstrap/js/collapse'

import '@bikemap/js/legacy/utils'
import '@bikemap/js/legacy/forms'

import initGlobal, { initPageFooter, initPageHeader } from '@bikemap/js/integrations/global'
import { gettext, notifications } from './services'
import Dropzone from "dropzone"
import "jquery-ui/ui/widgets/sortable.js"
import { initRemoveRouteButtons, initDeleteBtn, initTutorial, makeRouteCollectionEditable } from '@bikemap/js/legacy/route/collection'
import { initReportLinks } from './integrations/support'

initGlobal()
initPageHeader()
initPageFooter()

initReportLinks()

$(function() {
  "use strict"

  $('[data-toggle="tooltip"]').tooltip()

  var mainElement = document.body.querySelector("main")

  $.ajax({
    url: mainElement.dataset.userPermissionsUrl,
    method: "GET",
    headers: { "Cache-Control": "no-cache", "Ignore-It": "True" }
  }).done(function(data) {
    if (data.is_authenticated === true) {
      if (data.edit === true) {
        makeRouteCollectionEditable()

        var previewImageDataUrl
        var $previewImageDropzoneElement = $(".change-preview-image .btn")
        var previewImageDropzone = new Dropzone(".change-preview-image .btn", {
          url: $previewImageDropzoneElement.data('href'),
          acceptedFiles: ".png,.jpg,.jpeg",
          thumbnailWidth: null,
          thumbnailHeight: null,
          maxFilesize: 3,
          maxFiles: 1,
          paramName: "preview_image",
          autoProcessQueue: true,
          previewTemplate: $("#dropzone-preview-template-preview-image").html(),
          clickable: ".change-preview-image *",
          headers: { "X-CSRFToken": $.outdoorish.readCookie("csrftoken") },
          dictInvalidFileType: django.gettext(
            "Only JPG and PNG files are supported."
          ),
          dictFileTooBig: django.gettext(
            "This file exceeds the maximum allowed filesize ({{maxFilesize}} MiB): {{filesize}} MiB"
          )
        })

        previewImageDropzone.on("thumbnail", function(file, thumbnailUrl) {
          if (this.getUploadingFiles().length === 1) {
            previewImageDataUrl = thumbnailUrl
          }
        })

        previewImageDropzone.on("processing", function() {
          $previewImageDropzoneElement.addClass("loading-spinner")
        })

        previewImageDropzone.on("success", function(file, resp) {
          if (resp.status === "success") {
            if (
              $(".routecollection-image-container").hasClass("has-title-image")
            ) {
              $(".img-cover").attr("src", previewImageDataUrl)
              $(".img-cover").attr("srcset", "")
            } else {
              $(".title-content").addClass("has-title-image")
              $(".routecollection-image-container").addClass("has-title-image")
              $(".routecollection-image-container").append(
                '<img class="title-image img-cover col-xs-12" data-object-fit ' +
                  'src="' +
                  previewImageDataUrl +
                  '" alt="' +
                  $(".title")
                    .text()
                    .trim() +
                  '" />'
              )
            }
          } else {
            var errorMsg = gettext(
              "Oh no. An Error occurred while uploading {file}, the server responded with: {message}"
            )
              .replace('{file}', file.name)
              .replace('{message}', resp.msg)
            notifications.show({
              title: django.gettext("Upload failed"),
              icon: "i-warning-sign",
              message: errorMsg,
              type: "danger"
            })
          }

          this.removeAllFiles()
        })

        previewImageDropzone.on("error", function(file, msg, xhr) {
          if (xhr === undefined) {
            this.removeFile(file)
            notifications.show({
              title: django.gettext("Upload failed"),
              icon: "i-warning-sign",
              message: msg,
              type: "danger"
            })
          } else {
            var errorMsg = gettext(
              "Oh no. An Error occurred while uploading {file}, the server responded with: {status}"
            )
              .replace('{file}', file.name)
              .replace('{status}', xhr.statusText)
            notifications.show({
              title: django.gettext("Upload failed"),
              icon: "i-warning-sign",
              message: errorMsg,
              type: "danger"
            })
          }
        })

        previewImageDropzone.on("complete", function() {
          $previewImageDropzoneElement.removeClass("loading-spinner")
        })

        var $collectionItemsSortableElement = $("#collection-items-sortable")
        $collectionItemsSortableElement.sortable({
          axis: "y",
          cancel: ".collection-route-delete",
          start: function(event, ui) {
            ui.item.startPos = ui.item.index()
          },
          beforeStop: function() {
            var routes = $collectionItemsSortableElement[0].querySelectorAll(
              ".tile-collection-list"
            )
            var positions = {}
            for (var i = 0; i < routes.length; i++) {
              positions[routes[i].dataset.routeId] = i
            }
            $.ajax({
              url: $collectionItemsSortableElement.data("reorderRoutesUrl"),
              method: "POST",
              headers: { "X-CSRFToken": $.outdoorish.readCookie("csrftoken") },
              data: {
                positions: JSON.stringify(positions),
                modified: $collectionItemsSortableElement.data("routecollectionModified"),
              }
            }).done(function(jqXHR) {
              if (jqXHR.status === "error") {
                $collectionItemsSortableElement.sortable("cancel")
                $collectionItemsSortableElement.sortable("disable")
                $(".tile-collection-handle").remove()
                notifications.show({
                  title: django.gettext("Warning") + ": " + jqXHR.title,
                  icon: "i-warning-sign",
                  message: jqXHR.msg,
                  type: "warning"
                })
              } else {
                $(".tile-collection-counter").each(function(index) {
                  $(this).text(index + 1)
                })
              }
            })
          }
        })

        initTutorial(!data.seen_hint)

        initRemoveRouteButtons()
      }

      if (data.delete === true) {
        $("#edit-buttons").removeClass("hidden")
        $("#tutorial-button").removeClass("hidden")

        initDeleteBtn()
      }
    }
  })

  $("#button-facebook").on("click", function(event) {
    event.preventDefault()
    window.open(
      this.href,
      "fbwindow",
      "height=650, width=575, top=" +
        ($(window).height() / 2 - 225) +
        ", left=" +
        $(window).width() / 2
    )
  })

  $("#button-twitter").on("click", function(event) {
    event.preventDefault()
    window.open(
      this.href,
      "twitterwindow",
      "height=450, width=550, top=" +
        ($(window).height() / 2 - 225) +
        ", left=" +
        $(window).width() / 2
    )
  })
})
